import { expVal } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';

/**
 * Height the top nav contributes to the banner stack offset.
 *
 * Nav4 is fully rolled out, so the height is 48px by default and 56px when either the full-height
 * sidebar experiment or the app switcher improvements gate is on.
 *
 * Callers should resolve this once and hold the result — `BannerStateContainer` does so in its
 * constructor, and `useBannerTotalHeight` does so in a mount-scoped `useMemo`. It is not reactive.
 */
export const resolveTopNavHeight = (): number => {
	if (
		// The increased height change is applied when FHS or app switcher improvements are enabled.
		// Ideally we could check `useIsFhsEnabled()` but this has to work outside React too.
		// eslint-disable-next-line confluence-feature-gating/no-preconditioning
		expVal('navx-full-height-sidebar-exp', 'isEnabled', false) ||
		// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
		fg('platform_dst_ads_appswitcher_improvements')
	) {
		return 56;
	}

	return 48;
};
